/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandAppstore = createReactComponent("brand-appstore", "IconBrandAppstore", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488", key: "svg-1" }],
  ["path", { d: "M7 14h5m2.9 0h2.1", key: "svg-2" }],
  ["path", { d: "M16 16l-2.51 -4.518m-1.487 -2.677l-1 -1.805", key: "svg-3" }]
]);

export { IconBrandAppstore as default };
//# sourceMappingURL=IconBrandAppstore.js.map
